// extracted by mini-css-extract-plugin
export var desc = "card-module--desc--WGg62";
export var head = "card-module--head--lpgv1";